module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Blonay-Saint-Legier_COA-7a6104409727ff22b6996e2249c30d91.svg";